export const environment = {
  production: false,
  domain: 'devprimerx.us.auth0.com',
  clientId: 'KneXSu7eQOnnaC1a7r9THQheVR6WGD4W',
  audience: 'https://api.qa.eprimerx.com',
  apiBaseUrl: 'http://localhost:5000/',
  configStoreApiUrl: 'https://api.dev.pos.eprimerx.com',
  pageSizeForDashboard: 10,
  pageSize: 25,
  allowedUser: ['*']
};
